import React, { MouseEvent } from 'react';
import PropTypes from 'prop-types';

type ButtonProps = {
  label: string;
  onClick?: (e: MouseEvent) => void;
  type?: 'button' | 'submit' | 'reset';
  small?: boolean;
  secondary?: boolean;
  className?: string;
  disabled?: boolean;
  red?: boolean;
  name?: null | string;
};

function Button({
  label,
  onClick,
  type = 'button',
  small,
  secondary,
  className = '',
  disabled,
  red,
  name = null,
}: ButtonProps) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      onClick={onClick}
      className={`
        uds-button
        ${small ? 'uds-button--small' : ''}
        ${secondary ? 'uds-button--secondary' : ''}
        ${red ? 'uds-button--red' : ''}
        ${className}
      `}
      disabled={disabled}
      data-name={name}
      data-cy={name}
    >
      {label}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  small: PropTypes.bool,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  red: PropTypes.bool,
};

export default Button;
